import { render, staticRenderFns } from "./AccessoSpid.vue?vue&type=template&id=3214172d&scoped=true"
import script from "./AccessoSpid.vue?vue&type=script&lang=js"
export * from "./AccessoSpid.vue?vue&type=script&lang=js"
import style0 from "./AccessoSpid.vue?vue&type=style&index=0&id=3214172d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3214172d",
  null
  
)

export default component.exports